import { render, staticRenderFns } from "./WalletPayment.vue?vue&type=template&id=fd62e2d2"
import script from "./WalletPayment.vue?vue&type=script&lang=js"
export * from "./WalletPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports